import styles from './adBanner.module.css';

const CRAdBanner = () => {
    return (
        <>
            <section className={styles.AdBannerWrap}>
                <div className={styles.AdBanner}>
                    <div className={styles.InnerAdBanner}>
                        <a href="/agent-pricing#pricing" target="_blank">
                            <span>
                                Click Here to List a Property
                            </span>
                        </a>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CRAdBanner;